<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box create_report_modal">
      <button
        class="close_modal close_btn"
        @click="closeModal()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h3 class="heading_h4 font_bold mb_16">
        {{ widgetModal.widget ? 'Edit' : 'Create' }} Header Widget
      </h3>

      <div :class="'section_wrap '+(settings === 'widget' ? 'open' : '')">
        <div
          class="section_head"
          @click="(settings === 'widget' ? settings = '' : settings = 'widget')"
        >
          <h3 class="section_heading">
            Widget Settings
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings === 'widget'"
            class="section_body"
          >
            <custom-input
              v-model="widget.name"
              label="Widget name"
              placeholder="Enter a title for the widget (optional)"
              width="full"
            />

            <custom-input
              v-model="widget.attributes.text"
              label="Header text"
              placeholder="Enter the text for your header"
              width="full"
            />

            <custom-select
              v-model="widget.attributes.size"
              :options="{
                'h1': 'H1',
                'h2': 'H2',
                'h3': 'H3',
                'h4': 'H4',
                'h5': 'H5',
              }"
              label="Header size"
              width="half"
            />

            <custom-select
              v-model="widget.attributes.justify"
              :options="{
                'center': 'Centre',
                'flex-end': 'Right',
                'flex-start': 'Left'
              }"
              label="Header Align"
              width="half"
            />
          </div>
        </accordion-transition>
      </div>

      <div class="flex items-center section_modal_footer">
        <button
          class="btn btn_md secondary_btn close_modal ml_auto mr_8"
          @click="closeModal()"
        >
          <span>Cancel</span>
        </button>
        <button
          class="btn btn_md primary_btn"
          @click="save()"
        >
          <span>{{ widgetModal.widget ? 'Update' : 'Create' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import _ from 'lodash';
import CustomInput from '../../global/forms/CustomInput.vue';
import CustomSelect from '../../global/forms/CustomSelect.vue';
import AccordionTransition from '../../global/transitions/AccordionTransition.vue';

export default {
  components: {
    CustomInput,
    CustomSelect,
    AccordionTransition
  },
  emits: ['refresh-widget'],
  data() {
    return {
      settings: 'widget',
      widget: {
        id: `widget-heading-${Date.now()}`,
        name: 'Heading Widget',
        type: 'heading',
        w: 6,
        h: 25,
        attributes: {
          text: '',
          size: '',
          justify: ''
        },
        content: ''
      },
    }
  },
  computed: {
    ...mapState(['widgetModal'])
  },
  beforeMount() {
    if (this.widgetModal.widget) _.merge(this.widget, this.widgetModal.widget);
  },
  methods: {
    ...mapActions('pages', ['addWidget', 'updateWidget']),
    ...mapActions('widgetModal', ['closeModal']),
    async save() {
      this.widget.content = `<div id="widget-header-${Date.now()}">
                <div style="height: 100%; display:flex; align-items: center; justify-content: ${this.widget.attributes.justify};">
                    <${this.widget.attributes.size}>${this.widget.attributes.text}</${this.widget.attributes.size}>
                </div>
            </div>`;

      // Prep a payload for the vuex action
      const payload = {
        widget: this.widget,
        pageId: this.widgetModal.pageId,
      }

      // Check if we're creating a new widget or editing one
      if (!this.widgetModal.widget) {
        // Save the new pages layout (refreshes store pages)
        await this.addWidget(payload);
      } else {
        // Update the widget
        await this.updateWidget(payload);
      }

      // Emit to trigger widget refresh, then close the modal
      this.$emit('refresh-widget', {pageId: this.widgetModal.pageId, widget: this.widget});
      this.closeModal();
    }
  }
}
</script>

<style scoped src="../../../../reports/css/modal.css" />
